/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfMedication } from '../models/data-page-of-medication';
import { medicationList } from '../fn/medication/medication-list';
import { MedicationList$Params } from '../fn/medication/medication-list';

@Injectable({ providedIn: 'root' })
export class MedicationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `medicationList()` */
  static readonly MedicationListPath = '/medication/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicationList()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicationList$Response(params?: MedicationList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfMedication>> {
    return medicationList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicationList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicationList(params?: MedicationList$Params, context?: HttpContext): Observable<DataPageOfMedication> {
    return this.medicationList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfMedication>): DataPageOfMedication => r.body)
    );
  }

}
